module.exports = __webpack_public_path__ + "static/media/loading.649a6d47.gif";